export enum IntegrationEventName {
  CartItemsQuantity = 'cartItemsQuantity/',
}
